import { useTranslation } from 'react-i18next';

import { CommonSettings } from './common-settings';

export const ObjectsSettings = () => {
  const { t } = useTranslation();

  return <CommonSettings label={t('furniture')}>{t('children')}</CommonSettings>;
};
